import { render, staticRenderFns } from "./Tariffzones.vue?vue&type=template&id=2058b165&scoped=true&"
import script from "./Tariffzones.vue?vue&type=script&lang=js&"
export * from "./Tariffzones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058b165",
  null
  
)

export default component.exports